import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils/utils";
import { Input } from "../../ui/input";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { HTMLInputTypeAttribute } from "react";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../ui/form";

// Generic over the form's own field type rather than `Control<any>`: with
// `any`, react-hook-form's validate callbacks stop being assignable in either
// direction, so the first strict caller fails to compile.
interface CommonInputProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  placeholder?: string;
  type: HTMLInputTypeAttribute;
  className?: string;
}
const CommonInput = t0 => {
  const $ = _c(9);
  const {
    control,
    name,
    label,
    placeholder,
    type: t1,
    className
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  let t2;
  if ($[0] !== className || $[1] !== label || $[2] !== placeholder || $[3] !== type) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem><FormLabel className="font-semibold uppercase">{label}</FormLabel><FormControl><Input type={type} placeholder={placeholder} autoComplete="off" {...field} className={cn("h-14 px-4 common-input", className)} /></FormControl><FormMessage className="text-[0.65rem] font-bold" /></FormItem>;
    };
    $[0] = className;
    $[1] = label;
    $[2] = placeholder;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== control || $[6] !== name || $[7] !== t2) {
    t3 = <FormField control={control} name={name} render={t2} />;
    $[5] = control;
    $[6] = name;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default CommonInput;